import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { base_url } from "../utils/axiosConfig";

const TermAndConditions = () => {
  const [terms, setTerms] = useState('');

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const response = await axios.get(`${base_url}/master/getterm`);
        if (response.data && response.data.length > 0) {
          setTerms(response.data[0].name);
        }
      } catch (error) {
        console.error('Error fetching terms:', error);
      }
    };

    fetchTerms();
  }, []);

  return (
    <section className="py-5" style={{ background: "#f5f7fa" }}>
      <div className="container">
        
        {/* HEADER */}
        <div className="text-center mb-4">
          <h2 className="fw-bold" style={{ color: "#222" }}>
            Terms & Conditions
          </h2>
          <p className="text-muted">
            Please read these policies before using our services.
          </p>
        </div>

        {/* CARD */}
        <div className="card shadow-sm border-0 rounded-4">
          <div className="card-body p-4">
            
            {/* SCROLLABLE CONTENT */}
            <div
              className="overflow-auto"
              style={{
                maxHeight: "500px",
                paddingRight: "5px"
              }}
              dangerouslySetInnerHTML={{ __html: terms }}
            />

          </div>
        </div>

      </div>
    </section>
  );
};

export default TermAndConditions;
